import styled from "styled-components";

export const StyledOptimization = styled.div`
  background-color: var(--color-contrast-white) !important;
  min-height: calc(100vh - 45px);
  box-sizing: border-box;

  .content {
    height: 100%;
    overflow-x: auto;
    padding: 17px 20px 0 20px;
    display: flex;
    justify-content: center;
    background-color: var(--color-contrast-white);
  }

  .content-internal {
    width: 100%;
  }

  &.sequential-priority-active .content-expandable-table-optimization {
    height: calc(100vh - 390px);
  }

  @media (max-width: 768px) {
    &.sequential-priority-active .content-expandable-table-optimization {
      height: calc(100vh - 350px);
    }
  }

  .header {
    width: 100%;
    display: flex;
    justify-content: space-between;
    height: 70px;

    .header-icon {
      padding-left: 0;
    }
  }

  .button-container {
    margin-top: 10px;
    width: 100%;
    display: flex;
    justify-content: flex-end;
    align-items: center;
  }

  .button-selected {
    background-color: #b3cef4;
  }

  .center-align {
    width: 100%;
    text-align: center;
  }

  .button-filter-search {
    margin-right: 1px !important;
    width: 130px !important;
  }

  .sequential-priority-step {
    font-size: 32px;
    font-weight: 700;
    letter-spacing: 0.02em;
    color: var(--color-neutral-500);
    opacity: 0.35;
    transition: opacity 120ms ease, color 120ms ease, transform 120ms ease;
  }

  .sequential-priority-step-active {
    color: var(--color-action-default);
    opacity: 1;
    transform: translateY(-1px);
  }

  .sequential-priority-arrow {
    display: inline-flex;
    align-items: center;
    justify-content: center;
    width: 20px;
    height: 20px;
    color: var(--color-neutral-500);
    opacity: 0.35;
    line-height: 1;
  }

  .sequential-priority-arrow svg {
    width: 20px !important;
    height: 20px !important;
  }

  .column-codigo-link {
    font-weight: bold;
    color: var(--color-action-default);
    text-decoration: underline;
    cursor: pointer;
  }

  .column-alert-erro {
    color: #ff5e53;
  }
  `;

export const CodigoLink = styled.div``;

export const ActionButtonsContainer = styled.div`
  margin-top: 10px;
  width: 100%;
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  flex-wrap: nowrap;
  gap: 20px;

  .action-left-column {
    flex: 1 1 50%;
    min-width: 0;
    display: flex;
    justify-content: flex-start;
    padding-left: 16px;
  }

  .action-right-column {
    flex: 1 1 50%;
    min-width: 0;
    display: flex;
    justify-content: flex-end;
    align-items: flex-start;
    gap: 10px;
    flex-wrap: wrap;
  }

  .action-right-column .filterContainer {
    display: flex;
  }

  .action-right-column .button-filter-vision-sendToTransport {
    .button-text {
      color: white;
    }
  }

  .action-right-column .button-filter-vision-alternateToHistoric {
    margin-right: 20px;
  }

  .action-right-column .button-filter-vision svg {
    padding: 0px !important;
  }

  .sequential-priority-container {
    width: 100%;
    margin: 0;
    padding-left: 4px;
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: center;
    gap: 4px;
    box-sizing: border-box;
  }

  .sequential-priority-main-row {
    width: 100%;
    display: flex;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 50px;
    flex-wrap: nowrap;
    padding-left: 0;
  }

  .sequential-priority-left-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 6px;
    flex: 0 0 auto;
    width: fit-content;
    min-width: 0;
  }

  .sequential-priority-flow {
    display: flex;
    align-items: center;
    flex-wrap: wrap;
    gap: 8px;
    min-width: 0;
    justify-content: flex-start;
    flex: 0 0 auto;
  }

  .sequential-priority-reference-column {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    justify-content: flex-start;
    gap: 8px;
    flex: 0 0 200px;
    margin-left: 0;
  }

  .sequential-priority-description {
    color: var(--color-action-default);
    font-size: 14px;
    font-weight: 600;
    line-height: 1.25;
    max-width: 220px;
    overflow-wrap: anywhere;
  }

  .sequential-priority-reference {
    width: 100%;
    margin-left: 0;
  }

  .sequential-priority-reference > div,
  .sequential-priority-reference input {
    width: 100%;
  }

  .sequential-priority-reset {
    width: 100%;
    align-self: flex-start;
    margin-left: 0;
  }

  .sequential-priority-reset button {
    width: 100%;
  }
`;
